var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"leftBox"},_vm._l((_vm.list),function(item,index){return _c('div',{staticClass:"li",class:index == _vm.listOn ? 'on' : '',on:{"click":function($event){return _vm.listClick(index, item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }